import React from 'react';
import Searchicons from '@material-ui/icons/Search';
import ClearIcons from '@material-ui/icons/Close';
import { Grid, Button, TextField, IconButton } from '@material-ui/core';

import './style.css';

function SearchonMainPage({ handleSearch }) {
  const [value, setValue] = React.useState('');

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch(value);
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, [value]);

  return (
    <Grid container>
      <div className='welcome-to-the-sure-p'>
        Welcome to the SurePrep Developer Portal
      </div>
      <div className='tax-automation-made'>
        Tax Automation, Made Easy
      </div>
      <Grid container className='searchbox' item lg={12} onKeyDown={handleKeyDown}>
        <Grid container spacing={0}>
          <div className='searchborder'>
            <div className='colSearch'>
              <Searchicons className='searchIcon' />
            </div>
            <div className='colSearchtxt'>
              <TextField id='searchxtxfield'
                placeholder="CLICK HERE TO SEARCH API PRODUCTS..."
                type="text"
                variant="filled"
                fullWidth
                size="small"
                onChange={(e) => {
                  setValue(e.target.value);
                  handleSearch(e.target.value);
                  if (e.target.value === '') {
                    handleSearch('');
                  }
                }}
                value={value}
                InputProps={{
                  endAdornment: value && (
                    <IconButton
                      onClick={() => {
                        setValue('');
                        handleSearch('');
                      }}
                    >
                      <ClearIcons className='clearIcon' />
                    </IconButton>
                  )
                }}
              />
            </div>
            <div className='colsearchBtn'>
              <Button className='searchBtn' onClick={() => handleSearch(value)}>
                Search
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SearchonMainPage;
